import React, { useState } from "react";
import clsx from "clsx";
import {
	Container,
	Row,
	Col,
	Button,
	ButtonToolbar,
	ButtonGroup,
} from "reactstrap";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { Link } from "react-router-dom";
import Image from "../../../components/Image";
const caseInfo = {
	source: "Sebastian Romo",
};

export default function SchoolBus() {
	return (
		<TabPane tabId={"school-bus"}>
			<Row style={{ padding: 16 }}>
				<Col xs="12" sm={{ size: 12 }}>
					<h4>School Bus</h4>
				</Col>
				<Col xs="12" sm={{ size: 12 }}>
					<p>
						The animations below shows the spread of viral aerosols during two
						minutes in a typical twelve-row school bus with one adult driver and
						a single child in each seat.{" "}
						<strong>
							The bus is equipped with a ventilation system that supplies fresh
							outdoor air to the front section with two air inlets located in
							front of the driver, three inlets located at floor level next to
							the door, and two inlets located next to the door right below the
							windshield.
						</strong>{" "}
						One air return outlet is located under the console next to the
						driver and another one above the floor outlets at the door. The
						windows and the door are closed to represent the likely scenario as
						outdoor temperatures drop through the fall and winter. Represented
						in red are two infected children who would release viral aerosols
						through their exhalation.
					</p>
				</Col>
				<Col xs="12" sm={{ size: 10, offset: 1 }}>
					<Row>
						<Col xs={12} sm={6}>
							<h5 className="text-center">Case 1: School Bus Half Occupancy</h5>
							<figure className="figure">
								<Image
									src={`images/covid/schoolbus/half_occupancy.gif`}
									alt=""
								/>

								<figcaption className="figure-caption">
									Animation of exhaled particle velocities of 2 infected
									occupants in a half occupancy school bus. Animation covers 2
									minutes.
								</figcaption>
								<figcaption className="figure-caption">
									Source: City@UMD [{caseInfo.source}]
								</figcaption>
							</figure>
						</Col>
						<Col xs={12} sm={6}>
							<h5 className="text-center">Case 2: School Bus Full Occupancy</h5>
							<figure className="figure">
								<Image
									src={`images/covid/schoolbus/full_occupancy.gif`}
									alt=""
								/>
								<figcaption className="figure-caption">
									Animation of exhaled particle velocities of 2 infected
									occupants in a full occupancy school bus. Animation covers 2
									minutes.
								</figcaption>
								<figcaption className="figure-caption">
									Source: City@UMD [{caseInfo.source}]
								</figcaption>
							</figure>
						</Col>
					</Row>
				</Col>
				<Col xs={12} sm={{ size: 12 }}>
					<p>
						The location of the inlets and outlets create an inner air current
						flowing towards the back of the bus which reaches the first couple
						rows before getting redirected back to the front towards the outlet.
						This circulating pattern is known as a vortex and it is concentrated
						in the driver's cabin. As shown in the animation, the{" "}
						<strong>
							{" "}
							viral aerosol emitted by the infected child in the front quickly
							gets captured by this vortex and is rapidly carried towards the
							front of the bus. As the viral aerosol quickly spreads through
							these inner air currents it gets diluted in the larger volume of
							fresh outdoor air and the air inside the cabin.
						</strong>{" "}
						This means that while some viral particles can reach other
						occupants, particularly those in located in front of the infected
						child, the viral concentration gets diluted.
					</p>
					<p>
						Conversely,{" "}
						<strong>
							the fresh air streams do not reach all the way to the back of the
							bus, resulting in lower ventilation and a smaller spread of the
							viral aerosol exhaled by the infected child in the back.
						</strong>{" "}
						As shown in the animation, the viral aerosol impacts the back of the
						seat located right in front of the infected child, and a fraction
						then flows over the seat and through the window side to accumulate
						area of the seat in front.
					</p>
				</Col>
			</Row>
		</TabPane>
	);
}
